import React, { useContext, useEffect } from "react";
import Header from "./components/Common/Header";
import Navbar from "./components/Common/Navbar";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import Operator from "./pages/operator/Operator";
import Contribution from "./pages/contribution/Contribution";
import Quality from "./pages/quality/Quality";
import { NotificationContext } from "./context/NotificationContext";
import FloatingNotifications from "./components/Common/FloatingNotifications";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import { useAuthContext } from "./context/AuthProvider";
import LoginLayout from "./pages/login/LoginLayout";
import Wrapper from "./components/Common/Wrapper";
import Settings from "./components/Common/Settings";
import Configuration from "./pages/configuration/Configuration";
import QualityInfo from "./pages/quality/Components/QualityInfo";
import Metrices from "./pages/metrices/Metrices";
import Cookies from "js-cookie";
import Refinary from "./components/Common/Refinary";
import Summary from "./pages/summary/Summary";
import AMLProcessSheet from "./pages/aml-process-sheet/AMLProcessSheet";

function App() {
  const { authState, setAuthState } = useAuthContext();
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("role"));
    setAuthState({
      ...authState,
      isLoggedIn: data?.isLoggedIn,
      tokens: data?.tokens,
    });
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<LoginLayout />}>
        <Route index element={<Login />} />
      </Route>
      <Route path="/" element={<Wrapper />}>
        {Cookies.get("authToken") === "Manager" ? (
          <Route index element={<Home />} />
        ) : Cookies.get("authToken") === "Operator" ? (
          <Route path="/" element={<Navigate to="/live-production" />} />
        ) : (
          setAuthState({
            isLoggedIn: false,
          })
        )}
        <Route path="/live-production" element={<Operator />} />
        <Route path="/quality" element={<Quality />} />
        <Route path="/qualityInfo/:id" element={<QualityInfo />} />
        {/* <Route path="/contribution" element={<Contribution />} /> */}
        <Route path="/configuration" element={<Configuration />} />
        <Route path="/control" element={<Metrices />} />
        <Route path="/summary" element={<Summary />} />
        {/* <Route path="/aml" element={<AMLProcessSheet />} /> */}
        <Route path="/settings" element={<Settings />} />
        <Route path="/plant" element={<Refinary />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
}

export default App;
